var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[(_vm.$route.path.includes('/apply'))?_c('AppBar'):_c('AppBarPanel'),_c('v-main',[_c('router-view')],1),(_vm.$route.path.includes('/apply') && !this.$store.state.loading)?_c('Sponsors'):_vm._e(),(_vm.$route.path.includes('/apply') && !this.$store.state.loading)?_c('v-footer',{attrs:{"color":"primary"}},[_c('AppFooter')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }